<template>
  <Modal :open="open" @closed="closeModal">
    <div class="modal-header border-0">
      <h5 class="modal-title m-0">Select Your Manager</h5>
      <button @click="closeModal" type="button" class="btn-close outline-none"></button>
    </div>
    <div class="modal-body">
      <p class="text-muted mb-3">
        Please select your manager for the review cycle: <strong>{{ cycleName }}</strong>
      </p>

      <form @submit.prevent="save">
        <div class="mb-3">
          <label for="managerSelect" class="form-label">Manager <span class="text-danger">*</span></label>
          <select
            id="managerSelect"
            v-model="selectedManager"
            class="form-select"
            :class="{ 'is-invalid': showValidation && !selectedManager }"
            required
           data="">
            <option value="">Choose a manager...</option>
            <option v-for="manager in managers" :key="manager.id" :value="manager.id">
              {{ manager.first_name }} {{ manager.last_name }}
            </option>
          </select>
          <div v-if="showValidation && !selectedManager" class="invalid-feedback">
            Please select a manager
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button type="button" class="btn btn-outline-secondary me-2" @click="closeModal">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="saving || !selectedManager"
          >
            <span v-if="saving" class="spinner-border spinner-border-sm me-2" role="status"></span>
            Start Review
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modal/Modal.vue'

export default {
  name: 'ManagerSelectionModal',
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    cycleName: {
      type: String,
      default: ''
    },
    managers: {
      type: Array,
      default: () => []
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedManager: '',
      showValidation: false
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    closeModal() {
      if (!this.saving) {
        this.$emit('close')
      }
    },
    save() {
      if (!this.selectedManager) {
        this.showValidation = true
        return
      }

      this.$emit('save', this.selectedManager)
    },
    resetForm() {
      this.selectedManager = ''
      this.showValidation = false
    }
  }
}
</script>

<style scoped>
/* Add any specific styling if needed */
</style>
